// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapContainer_wrapper__2pNRl","wrapper_full":"MapContainer_wrapper_full__3Wjc1"};